<template>
  <v-layout
    v-if="!$apollo.queries.projectInvestors.loading && !_.isEmpty(projectInvestors)"
    fluid 
    column
    style="height: 38vh"
  >
    <v-flex
      mb-4 
      style="overflow: auto"
    >       
      <v-data-table
        class="accounts text-no-wrap"
        :headers="headers"
        :items="projectInvestors"
        :hide-default-footer="true"
        :mobile-breakpoint="900"
        :items-per-page="200"
        dense
      >
        <template
          slot="headerCell"
          slot-scope="{ header }"
        >
          <span
            v-text="header.text"
          />
        </template>
        <template v-slot:item.investor="{ item }">
          {{ item.investor.name }}
        </template>
        <template v-slot:item.project="{ item }">
          <b class="ticker">{{ item.project.ticker }}</b>
        </template>
        <template v-slot:item.pnl_this_month="{ item }">
          <b :class="colorPnL(item.pnl_this_month * 100 / item.investor.account_balance)">
            {{ (item.pnl_this_month * 100 / (item.investor.account_balance - item.pnl_this_month)).toFixed(2) }}% 
          </b>
          <v-tooltip
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            <v-icon class="btc-icon-15 text-black">
              mdi-currency-btc
            </v-icon>
            {{ item.pnl_this_month }}
          </v-tooltip> 
        </template>
        <template v-slot:item.pnl_total="{ item }">
          <b :class="colorPnL(item.pnl_total * 100 / item.investor.account_balance)">
            {{ (item.pnl_total * 100 / (item.investor.account_balance - item.pnl_total)).toFixed(2) }}% 
          </b>
          <v-tooltip
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            <v-icon class="btc-icon-15 text-black">
              mdi-currency-btc
            </v-icon>
            {{ item.pnl_total }}
          </v-tooltip>
        </template>
        <template v-slot:item.aum="{ item }">
          <v-icon class="btc-icon-12 text-black">
            mdi-currency-btc
          </v-icon>
          <b>{{ item.investor.account_balance.toFixed(6) }}</b>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <v-layout
    v-else
    wrap
    fill-height
  >
    <v-flex
      class="not-found"
      align-self-center
    >
      <v-icon>mdi-ghost</v-icon>
      <p>{{ $t('traderdashboard.accountsNotFound') }}</p>
    </v-flex>
  </v-layout>
</template>

<script>

const PROJECT_INVESTORS_QUERY = require('@/graphql/queries/ProjectInvestors.gql');


export default {
  name: 'ConnectedInvestors',
  data() {
    return {
      loading: false,
      headers: [
        {
          sortable: false,
          text: this.$t('investors.investor'),
          value: 'investor'
        },
        {
          sortable: false,
          text: this.$t('investors.project'),
          value: 'project'
        },    
        {
          sortable: false,
          text: this.$t('globals.pnl_this_month'),
          value: 'pnl_this_month',
        },
        {
          sortable: false,
          text: this.$t('globals.pnl_total'),
          value: 'pnl_total',
        },
        {
          sortable: false,
          text: this.$t('globals.aum'),
          value: 'aum'
        },
      ]
    }
    
  },
  beforeDestroy() {
    this.$apollo.queries.projectInvestors.stopPolling()
  },
  methods: {
  },
  apollo: {
    projectInvestors: {
      query: PROJECT_INVESTORS_QUERY,
      variables: {
        status: ["connected"]
      },
      fetchPolicy: 'network',
      pollInterval: 60000,
      result ({ data, loading, networkStatus }) {
        if (loading == false && !_.isEmpty(data.projectInvestors)) {
          this.$emit('triggerButton', true)
          this.$emit('countAccs', data.projectInvestors.length)
        }
      },
    }
  },
}
</script>

<style lang="scss" scoped>
  .ticker {
    font-weight: 700;
    color: #9c27b0;
  }
  .accounts {
    .v-icon {
      margin-top:-2.5px;
      font-size:13px;
    }
  }
  

</style>
